export class GWDestination                                                                           {
    public id: number;
    public eventId: number;
    public destination: string;
    public countryIso2: string;
    public stateIso2: string;
    public city: string;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/models/agents-gateway/save-quote/gw-destination.model.ts